import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ROUTE_CONST } from "../Constants/route.constant";

import Loader from "../Components/Loader";

const Home = lazy(() => import("../Components/LandingPage/Home"));
const MyTeam = lazy(() => import("../Components/MyTeam"));
const AssistantsComponent = lazy(() => import("../Components/Assistants"));
const DigitalEmployeeComponent = lazy(
  () => import("../Components/DigitalEmployee"),
);
const AgentsComponent = lazy(() => import("../Components/Agents"));
const Process = lazy(() => import("../Components/Processes"));
const Discover = lazy(() => import("../Components/Discover"));

const AppRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path={ROUTE_CONST.HOME} element={<Home />} />
        <Route path={ROUTE_CONST.AGENTS} element={<AgentsComponent />} />
        <Route
          path={ROUTE_CONST.ASSISTANTS}
          element={<AssistantsComponent />}
        />
        <Route
          path={ROUTE_CONST.DIGITAL_EMPLOYEE}
          element={<DigitalEmployeeComponent />}
        />
        <Route path={ROUTE_CONST.MYTEAM} element={<MyTeam />} />
        <Route path={ROUTE_CONST.PROCESSES} element={<Process />} />
        <Route path={ROUTE_CONST.DISCOVER} element={<Discover />} />
        <Route path="/*" element={<Navigate to={ROUTE_CONST.HOME} replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
